<template>
  <div class="mx-1">
    <NavigationBreadcrumb
      class="mb-3"
      :items="breadcrumb_items"
      :matterId="egress_profile_matter_id"
      :showEgressProfile="true"
      :showMatrix1="true"
      :showMatrix2="true"
      :showMatrix3="true"
      :showMatrix4="true"
      :showStudyPlan="true"
      :showCurricularMesh="true"
      :showMatterDescriptionView="true"
      :showLearningEvaluationView="true"
      :showLearningExperiencesView="true"
      :showPiaView="true"
      :showPaView="true"
    ></NavigationBreadcrumb>
    <div class="suitcase-header mt-3" v-if="suitcase_report">
      <div
        class="left-header-text"
        :style="{
          'background-color': facultyColor + '!important',
          color: $lightOrDark(facultyColor) ? 'black' : 'white',
        }"
      >
        <h1
          class="font-weight-bold text-center"
          :style="{ 'background-color': facultyColor }"
        >
          {{ $t("matterProgram.learningSuitcaseTeacherView.pda") }}
        </h1>
      </div>
      <h4 class="suitcase-faculty text-left">
        {{ suitcase_report.faculty_name }}
      </h4>
      <div class="logo-container">
        <h4
          class="suitcase-title mr-2"
          :class="{ 'suitcase-title--en': $i18n.locale === 'en' }"
        >
          {{
            $t(
              "matterProgram.learningSuitcaseTeacherView.suitcase"
            ).toUpperCase()
          }}
          <span class="suitcase-title-2">{{
            $t(
              "matterProgram.learningSuitcaseTeacherView.didactic"
            ).toUpperCase()
          }}</span>
        </h4>
        <div class="logo-section ml-3">
          <b-img class="institution-logo" :src="institution_logo"></b-img>
        </div>
      </div>
    </div>
    <!-- Encabezado principal con información de asignatura -->
    <div class="synthesis-header-container">
      <div
        class="empty-block"
        :style="{
          'background-color': suitcase_report
            ? facultyColor + '!important'
            : '',
        }"
      ></div>
      <h5 class="synthesis-header mb-0 py-2 text-white">
        <strong>{{
          $t(
            "matterProgram.learningSuitcaseTeacherView.classroomDidacticPlanSynthesis"
          ).toUpperCase()
        }}</strong>
      </h5>
    </div>
    <b-table-simple
      class="page-break"
      v-if="suitcase_report"
      bordered
      responsive
    >
      <b-thead>
        <b-tr>
          <b-th
            class="second-header"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
            >{{ $getVisibleNames("manual.matter_code", false, "Código") }}</b-th
          >
          <b-th
            class="second-header"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
            >{{ $t("reusable.common.name") }}</b-th
          >
          <b-th
            class="second-header"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
            >{{
              $getVisibleNames("manual.credits", true, "Créditos SCT Totales")
            }}</b-th
          >
          <b-th
            v-if="$hasInstitutionalCredits(institution)"
            class="second-header"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
            >{{
              $getVisibleNames(
                "manual.institutional_credits",
                true,
                "Créditos Institucionales"
              )
            }}</b-th
          >
          <b-th
            class="second-header"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
            >{{
              $getVisibleNames(
                "mesh.modality",
                false,
                "Modalidad de Asignaturas"
              )
            }}</b-th
          >
          <b-th
            class="second-header"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
          >
            {{
              $getVisibleNames(
                "mesh.formationline",
                false,
                "Línea de Formación"
              )
            }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td
            class="align-middle"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
            >{{ suitcase_report.matter_code }}</b-td
          >
          <b-td
            class="align-middle"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
            >{{ suitcase_report.matter_name }}</b-td
          >
          <b-td
            class="align-middle"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
            >{{ suitcase_report.sct_credits }}</b-td
          >
          <b-td
            v-if="$hasInstitutionalCredits(institution)"
            class="align-middle"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
            >{{
              suitcase_report.duoc_credits ? suitcase_report.duoc_credits : "-"
            }}</b-td
          >
          <b-td
            class="align-middle"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
          >
            <template v-if="suitcase_report.modalities.length > 0">
              <div
                v-for="modality in suitcase_report.modalities"
                :key="modality.id"
                :variant="$lightOrDark(facultyColor) ? 'dark' : 'light'"
                class="mr-1"
              >
                {{ modality.name }}
              </div>
            </template>
            <template v-else>
              <div>{{ $t("reusable.common.notApplicable") }}</div>
            </template></b-td
          >
          <b-td
            class="align-middle"
            :style="{
              'background-color': facultyColor + '!important',
              color: $lightOrDark(facultyColor) ? 'black' : 'white',
            }"
          >
            {{ suitcase_report.formation_line }}
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <!-- *********************** SECCIÓN DE INFORMACIÓN GENERAL *********************** -->

    <b-table-simple
      class="page-break"
      v-if="suitcase_report"
      bordered
      responsive
    >
      <b-thead>
        <b-tr>
          <b-th colspan="9" class="first-header text-left"
            ><span class="general-background-icon mr-2">
              <b-icon icon="list-check"></b-icon>
            </span>
            1.
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.generalInformation"
              ).toUpperCase()
            }}
          </b-th>
        </b-tr>
        <b-tr>
          <b-th
            v-if="suitcase_report.matter_is_transversal == false"
            class="second-header"
            >{{
              $t(
                "matterProgram.learningSuitcaseTeacherView.careers"
              ).toUpperCase()
            }}</b-th
          >
          <b-th class="second-header">{{
            $t(
              "matterProgram.learningSuitcaseTeacherView.prerequisites"
            ).toUpperCase()
          }}</b-th>
          <!-- <b-th class="second-header">LINEA FORMATIVA</b-th> -->
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td
            v-if="suitcase_report.matter_is_transversal == false"
            class="text-left"
          >
            <template
              v-if="
                suitcase_report.other_careers &&
                suitcase_report.other_careers.length > 0
              "
            >
              <!-- :style="{
                    'background-color':
                      facultyColor + '!important',
                    color: $lightOrDark(facultyColor)
                      ? 'black'
                      : 'white',
                  }" -->
              <span>
                {{
                  suitcase_report.other_careers
                    .map((career) => career.egress_profile__career__name)
                    .join(", ")
                }}
              </span>
            </template>

            <template v-else>
              <div>{{ $t("reusable.common.notApplicable") }}</div>
            </template>
          </b-td>
          <b-td class="text-left">
            <template
              v-if="
                suitcase_report.prerequisites &&
                suitcase_report.prerequisites.length > 0
              "
            >
              <span>
                {{
                  suitcase_report.prerequisites
                    .map((prerequisite) => prerequisite.matter__name)
                    .join(", ")
                }}
              </span>
            </template>
            <template v-else>
              <div>{{ $t("reusable.common.notApplicable") }}</div>
            </template>
          </b-td>
          <!-- Linea Formativa -->
          <!-- <b-td>{{ suitcase_report.formation_line }}</b-td> -->
        </b-tr>
      </b-tbody>
    </b-table-simple>

    <!-- *********************** SECCIÓN OTRAS INDICACIONES ***********************-->
    <template v-if="suitcase_report">
      <div class="suitcase-matter-description mt-2">
        <div class="matter-description-header text-left">
          <span class="general-background-icon mr-2">
            <b-icon icon="gear"></b-icon>
          </span>
          2.
          {{
            $t(
              "matterProgram.learningSuitcaseTeacherView.subjectDescription"
            ).toUpperCase()
          }}
        </div>
        <div class="matter-description-body">
          <template v-if="suitcase_report.matter_description">
            <RenderVHtml
              :content="suitcase_report.matter_description"
            ></RenderVHtml>
          </template>
          <template v-else>
            <div>
              {{
                $t(
                  "matterProgram.learningSuitcaseTeacherView.noDescriptionForEntity",
                  {
                    entity: $getVisibleNames(
                      "mesh.egressprofilematter",
                      false,
                      "Asignatura"
                    ),
                  }
                )
              }}
            </div>
          </template>
        </div>
      </div>
    </template>

    <!-- *********************** SECCIÓN TABLA DE COMPETENCIAS ***********************-->

    <b-table-simple
      v-if="suitcase_report && suitcase_report.competence_dict_list.length"
      class="mt-2 mb-2 page-break"
      bordered
      responsive
    >
      <template v-if="suitcase_report.competence_dict_list.length > 0">
        <!-- Capacidades Institucionales -->
        <!-- TODO: OCULTADO TABLA CAPACIDADES -->
        <b-tr>
          <b-th class="suitcase-competences-th text-justify">
            {{ $getVisibleNames("mesh.capacity", true, "Capacidades") }}
          </b-th>
          <b-td class="suitcase-competences-td text-justify">
            <div v-if="suitcase_report.capacities.length == 0">
              {{
                $t(
                  "matterProgram.learningSuitcaseTeacherView.noEntityForSubject",
                  {
                    entity1: $getVisibleNames(
                      "mesh.capacity",
                      true,
                      "Capacidades"
                    ),
                    entity2: $getVisibleNames(
                      "mesh.egressprofilematter",
                      false,
                      "Asignatura"
                    ),
                  }
                )
              }}
            </div>
            <div v-else>
              <div>
                {{ suitcase_report.capacities.join(", ") }}
              </div>
            </div>
          </b-td>
        </b-tr>
        <template
          v-for="competence_dict_list in suitcase_report.competence_dict_list"
        >
          <template
            v-for="(competence, index) in competence_dict_list.competences"
          >
            <b-tr
              :key="
                competence_dict_list.egress_profile_name + '-' + competence.id
              "
            >
              <b-th
                :rowspan="competence_dict_list.competences.length"
                v-if="index == 0"
                class="suitcase-competences-th text-justify"
              >
                {{ $getVisibleNames("mesh.competence", true, "Competencias") }}:
                <template
                  v-if="suitcase_report.competence_dict_list.length > 1"
                >
                  "{{ competence_dict_list.egress_profile_name }}"
                </template>
              </b-th>
              <b-td class="suitcase-competences-td text-justify">
                <span v-if="competence.order">{{
                  "C" + competence.order + "."
                }}</span>
                {{ competence.full_sentence }}</b-td
              >
            </b-tr>
          </template>
        </template>
      </template>
      <!-- <template
        v-for="(competence, index) in suitcase_report.linked_competences"
      >
        <b-tr :key="competence.id">
          <b-th
            :rowspan="suitcase_report.linked_competences.length"
            v-if="index == 0"
            class="suitcase-competences-th"
          >
            {{ $getVisibleNames("mesh.competence", true, "Competencias") }}
            {{ egressProfileLinked ? 'de "' + egressProfileLinked.name : "" }}
          </b-th>
          <b-td class="suitcase-competences-td">
            <span v-if="competence.order">{{
              "C" + competence.order + "."
            }}</span>
            {{ competence.full_sentence }}</b-td
          >
        </b-tr>
      </template> -->
    </b-table-simple>

    <!-- *********************** SECCIÓN TABLA DE RESULTADOS DE APRENDIZAJE ***********************-->

    <b-table-simple
      v-if="suitcase_report && suitcase_report.learning_results.length"
      bordered
      responsive
      class="mt-2 page-break"
    >
      <b-thead>
        <b-th class="second-header">{{
          $t(
            "matterProgram.learningSuitcaseTeacherView.learningResults"
          ).toUpperCase()
        }}</b-th>
        <b-th class="second-header">{{
          $t(
            "matterProgram.learningSuitcaseTeacherView.achievementIndicator"
          ).toUpperCase()
        }}</b-th>
      </b-thead>
      <template
        v-for="(learning_result, index1) in suitcase_report.learning_results"
      >
        <template v-if="learning_result.evaluation_criterias_micro.length > 0">
          <b-tr
            v-for="(
              ec_micro, index2
            ) in learning_result.evaluation_criterias_micro"
            :key="'learning-result-' + index1 + 'ec-micro-' + index2"
          >
            <b-td
              class="suitcase-learning-results-td text-justify"
              :rowspan="learning_result.evaluation_criterias_micro.length"
              v-if="index2 == 0"
            >
              <span v-if="learning_result.order">{{
                "RA" + learning_result.order + "."
              }}</span>
              {{ learning_result.full_sentence }}</b-td
            >
            <b-td class="suitcase-ec-micro-td text-justify"
              >{{ "IL " + learning_result.order + "." + (index2 + 1)
              }}<span class="ml-2">{{ ec_micro.full_sentence }}</span>
            </b-td>
          </b-tr>
        </template>
        <template v-else>
          <b-tr :key="'learning-result-' + index1">
            <b-td class="suitcase-learning-results-td"
              ><span v-if="learning_result.order">{{
                "RA" + learning_result.order + "."
              }}</span>
              {{ learning_result.full_sentence }}</b-td
            >
            <b-td>{{ $t("reusable.common.notApplicable") }}</b-td>
          </b-tr>
        </template>
      </template>
    </b-table-simple>

    <!-- *********************** SÍNTESIS RUTA DE APRENDIZAJE ***********************-->
    <b-table-simple
      class="page-break"
      v-if="suitcase_report"
      bordered
      responsive
    >
      <b-thead>
        <b-tr>
          <b-th colspan="6" class="first-header text-left"
            ><span class="general-background-icon mr-2">
              <b-icon icon="clipboard-data"></b-icon>
            </span>
            3.
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.learningRouteSynthesis"
              ).toUpperCase()
            }}
          </b-th>
        </b-tr>
        <b-tr>
          <b-th class="thirth-header">{{
            $t(
              "matterProgram.learningSuitcaseTeacherView.learningResult"
            ).toUpperCase()
          }}</b-th>
          <b-th class="thirth-header">
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.achievementIndicator"
              ).toUpperCase()
            }}</b-th
          >
          <b-th class="thirth-header">
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.learningExperience"
              ).toUpperCase()
            }}</b-th
          >
          <b-th class="thirth-header">
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.activitiesAndEvaluations"
              ).toUpperCase()
            }}
          </b-th>
          <b-th class="thirth-header">
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.learningEnvironments"
              ).toUpperCase()
            }}
          </b-th>
          <b-th class="thirth-header">
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.hoursCount"
              ).toUpperCase()
            }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template
          v-for="(
            learning_result, index1
          ) in suitcase_report.learning_experiences"
        >
          <template
            v-for="(act_and_eva, index2) in activityAndEvaluation(
              learning_result
            )"
          >
            <b-tr :key="'learning-result' + index1 + 'act_and_eva' + index2">
              <b-td
                class="text-left align-middle"
                v-if="index2 == 0"
                :rowspan="
                  learning_result.activities.length +
                  learning_result.evaluations.length
                "
              >
                <!-- RESULTADO DE APRENDIZAJE -->
                <template v-if="learning_result.study_units.length > 0">
                  <b-badge
                    v-for="study_unit in learning_result.study_units"
                    :key="study_unit.id + '-' + index2"
                    variant="none"
                    pill
                    class="ra-badge mr-1 noprint"
                    v-b-tooltip.v-secondary.noninteractive.bottom="
                      study_unit.full_sentence
                    "
                  >
                    RA{{ study_unit.order }}
                  </b-badge>
                  <p
                    class="learning-result-badge1"
                    :key="'p-lr1' + study_unit.id + '-' + index2"
                    v-for="study_unit in learning_result.study_units"
                  >
                    {{ study_unit.full_sentence }}
                  </p>
                </template>
                <template v-else>
                  <div>{{ $t("reusable.common.notApplicable") }}</div>
                </template>
              </b-td>
              <b-td class="text-left align-middle">
                <!-- INDICADOR DE LOGRO -->
                <b-badge
                  v-for="evaluation_criteria in act_and_eva.evaluation_criterias_micro"
                  :key="evaluation_criteria.id + '-' + index2"
                  variant="none"
                  pill
                  class="il-badge mr-1"
                  v-b-tooltip.v-secondary.noninteractive.bottom="
                    evaluation_criteria.full_sentence
                  "
                >
                  {{
                    "IL" +
                    evaluation_criteria.study_unit__order +
                    "." +
                    evaluation_criteria.order
                  }}
                </b-badge>
                <!-- <p
                    class="evaluation-criteria-badge-activity"
                    v-for="evaluation_criteria in act_and_eva.evaluation_criterias_micro"
                    :key="'p-ec1' + evaluation_criteria.id+'-'+index2"
                  >
                    {{ evaluation_criteria.full_sentence }}
                  </p> -->
                <!-- <p
                    v-for="evaluation_criteria in act_and_eva.evaluation_criterias_micro"
                    :key="evaluation_criteria.id+'-'+index2"
                  >
                    <span v-if="evaluation_criteria.study_unit__order"
                      >{{
                        "IL" +
                        evaluation_criteria.study_unit__order +
                        "." +
                        evaluation_criteria.order
                      }}
                    </span>
                    <span>{{ evaluation_criteria.full_sentence }}</span>
                  </p> -->
              </b-td>
              <b-td
                class="text-left align-middle"
                v-if="index2 == 0"
                :rowspan="
                  learning_result.activities.length +
                  learning_result.evaluations.length
                "
              >
                <!--  EXPERIENCIA DE APRENDIZAJE -->
                <!-- <span v-if="learning_result.order">{{
                    "EA " + learning_result.order
                  }}</span>
                  - -->
                {{ learning_result.name }}
              </b-td>
              <b-td class="text-left">
                <!-- ACTIVIDADES Y EVALUACIONES -->
                <!-- Act {{ index1 + 1 }}.{{ index2 + 1 }} - -->
                <div>
                  {{ act_and_eva.name }}
                </div>
                <div v-if="act_and_eva.connection_with_the_environment == true">
                  <strong>{{
                    $t(
                      "matterProgram.learningSuitcaseTeacherView.activityAssociatedToVcm"
                    )
                  }}</strong>
                </div>
              </b-td>
              <b-td
                :class="[
                  act_and_eva.study_environments.length > 0
                    ? 'text-left'
                    : 'text-ceter',
                ]"
              >
                <!-- AMBIENTES DE APRENDIZAJE -->
                <template v-if="act_and_eva.study_environments.length > 0">
                  <span>
                    {{
                      act_and_eva.study_environments
                        .map((x) => x.name)
                        .join(", ")
                    }}
                  </span>
                </template>
                <template v-else>
                  <div class="text-left">
                    <span>{{ $t("reusable.common.notApplicable") }} </span>
                  </div>
                </template>
              </b-td>
              <b-td class="text-center">
                <!-- N° HORAS -->
                {{ act_and_eva.suggested_hours }}
              </b-td>
            </b-tr>
          </template>
        </template>
        <template
          v-if="
            suitcase_report.transversal_exams &&
            suitcase_report.transversal_exams.length > 0
          "
        >
          <template
            v-for="transversal_exam in suitcase_report.transversal_exams"
          >
            <b-tr :key="transversal_exam.id">
              <b-td colspan="3">
                <!-- Examen
                {{ transversal_exam.type_name }} -->
              </b-td>
              <b-td class="text-left">{{ transversal_exam.name }}</b-td>
              <b-td
                :class="[
                  transversal_exam.study_environments.length > 0
                    ? 'text-left'
                    : 'text-ceter',
                ]"
                ><template
                  v-if="transversal_exam.study_environments.length > 0"
                >
                  <div
                    v-for="(
                      environment, index
                    ) in transversal_exam.study_environments"
                    :key="environment.id"
                    variant="info"
                    class="mr-1"
                  >
                    {{ index > 0 ? ", " : "" }}{{ environment.name }}
                  </div>
                </template></b-td
              >
              <b-td>{{ transversal_exam.suggested_hours }}</b-td>
            </b-tr>
          </template>
        </template>
        <template
          v-if="
            suitcase_report.learning_experiences.length > 0 ||
            suitcase_report.transversal_exams.length > 0
          "
        >
          <b-tr>
            <b-td colspan="5">
              {{
                $t(
                  "matterProgram.learningSuitcaseTeacherView.total"
                ).toUpperCase()
              }}</b-td
            >
            <b-td>{{
              suitcase_report.total_egress_profile_matter_evaluation_hours
            }}</b-td>
          </b-tr>
        </template>
        <template
          v-if="
            suitcase_report.learning_results.length == 0 &&
            suitcase_report.transversal_exams.length == 0
          "
        >
          <b-td class="text-center" colspan="6">{{
            $t(
              "matterProgram.learningSuitcaseTeacherView.noLearningRouteSynthesis",
              {
                entity: $t(
                  "matterProgram.learningSuitcaseTeacherView.learningRouteSynthesis"
                ),
              }
            )
          }}</b-td>
        </template>
      </b-tbody>
    </b-table-simple>
    <!-- *********************** SECCIÓN DE EVALUACIONES PARCIALES  ***********************-->

    <b-table-simple
      class="page-break"
      v-if="suitcase_report"
      bordered
      responsive
    >
      <b-thead>
        <b-tr>
          <b-th colspan="5" class="first-header text-left"
            ><span class="general-background-icon mr-2">
              <b-icon icon="star"></b-icon>
            </span>
            4.
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.evaluations"
              ).toUpperCase()
            }}
          </b-th>
        </b-tr>
        <b-tr>
          <b-th class="second-header">{{
            $t(
              "matterProgram.learningSuitcaseTeacherView.evaluation"
            ).toUpperCase()
          }}</b-th>
          <b-th class="second-header">
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.evaluativeSituation"
              ).toUpperCase()
            }}</b-th
          >
          <b-th class="second-header">
            {{ $t("reusable.common.description").toUpperCase() }}
          </b-th>
          <b-th class="second-header">
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.partialEvaluationWeight"
              ).toUpperCase()
            }}</b-th
          >
          <b-th class="second-header">
            {{
              $t(
                "matterProgram.learningSuitcaseTeacherView.finalWeightingEvaluations"
              ).toUpperCase()
            }}{{
              suitcase_report.transversal_exams.length > 0 ? "/ET" : ""
            }}</b-th
          >
        </b-tr>
      </b-thead>
      <b-tbody>
        <template
          v-if="
            suitcase_report.partial_evaluations &&
            suitcase_report.partial_evaluations.length > 0
          "
        >
          <b-tr
            v-for="(evaluation, index) in suitcase_report.partial_evaluations"
            :key="evaluation.id"
          >
            <b-td class="text-left">{{ evaluation.name }}</b-td>
            <b-td class="text-left">
              {{
                evaluation.evaluation_situations.length == 0
                  ? $t("reusable.common.notApplicable")
                  : evaluation.evaluation_situations.join(", ")
              }}
            </b-td>
            <b-td class="text-left">
              <RenderVHtml :content="evaluation.description"></RenderVHtml>
            </b-td>
            <b-td>{{ evaluation.weighing | Round }}%</b-td>
            <b-td
              class="text-center align-middle"
              v-if="index == 0"
              :rowspan="suitcase_report.partial_evaluations.length"
              >{{ getTotalWeighing + "%" }}
            </b-td>
          </b-tr>
          <template
            v-if="
              suitcase_report.transversal_exams &&
              suitcase_report.transversal_exams.length > 0
            "
          >
            <template
              v-for="transversal_exam in suitcase_report.transversal_exams"
            >
              <b-tr :key="transversal_exam.id">
                <b-td class="text-left">{{ transversal_exam.name }}</b-td>
                <b-td class="text-left">
                  {{
                    transversal_exam.evaluation_situations.length > 0
                      ? transversal_exam.evaluation_situations.join(", ")
                      : $t("reusable.common.notApplicable")
                  }}
                </b-td>
                <b-td class="text-left">
                  <RenderVHtml
                    :content="transversal_exam.description"
                  ></RenderVHtml>
                </b-td>
                <b-td>-</b-td>
                <b-td>{{ transversal_exam.weighing + "%" }}</b-td>
              </b-tr>
            </template>
          </template>
          <template>
            <b-tr
              v-if="
                suitcase_report && suitcase_report.transversal_exams.length > 0
              "
            >
              <b-td colspan="4">
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.total"
                  ).toUpperCase()
                }}</b-td
              >
              <b-td>{{ getAllTotalWeighing }}%</b-td>
            </b-tr>
          </template>
        </template>
        <template v-else>
          <b-tr>
            <b-td class="text-center" colspan="5">{{
              $t(
                "matterProgram.learningSuitcaseTeacherView.noPartialEvaluations"
              )
            }}</b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>

    <!-- *********************** EXPERIENCIAS DE APRENDIZAJE  ***********************-->
    <template
      v-if="suitcase_report && suitcase_report.learning_experiences.length > 0"
    >
      <b-table-simple
        class="page-break"
        v-if="suitcase_report"
        bordered
        responsive
      >
        <b-thead>
          <b-tr>
            <b-th colspan="8" class="first-header text-left"
              ><span class="general-background-icon mr-2">
                <b-icon icon="handbag"></b-icon>
              </span>
              5.
              {{
                $t(
                  "matterProgram.learningSuitcaseTeacherView.learningExperiences"
                ).toUpperCase()
              }}
            </b-th>
          </b-tr></b-thead
        ></b-table-simple
      >
      <template v-for="learning_result in suitcase_report.learning_experiences">
        <b-table-simple
          class="page-break"
          bordered
          responsive
          :key="learning_result.id"
        >
          <b-thead>
            <b-tr>
              <b-th
                colspan="1"
                class="learning-result-order text-center"
                :style="{
                  'background-color': facultyColor + '!important',
                  color: $lightOrDark(facultyColor) ? 'black' : 'white',
                }"
              >
                {{ learning_result.order }}
              </b-th>
              <b-th colspan="7" class="first-header">
                <div class="learning-experiences-header-drop">
                  <span v-if="learning_result.order">{{
                    "EA " + learning_result.order
                  }}</span>
                  -
                  {{ learning_result.name }}
                </div>
              </b-th>
            </b-tr>
            <b-tr>
              <b-th colspan="8" class="second-header">
                {{ $t("reusable.common.description").toUpperCase() }}
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td colspan="8">
                <RenderVHtml
                  :content="learning_result.description"
                ></RenderVHtml>
              </b-td>
            </b-tr>
          </b-tbody></b-table-simple
        >
        <b-table-simple
          class="page-break"
          bordered
          responsive
          :key="'activity_' + learning_result.id"
        >
          <b-thead>
            <b-tr>
              <b-th colspan="5" class="first-header"
                ><span class="general-background-icon mr-2">
                  <b-icon icon="pencil"></b-icon>
                </span>
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.activities"
                  ).toUpperCase()
                }}
              </b-th>
            </b-tr>
            <b-tr>
              <b-th class="second-header">
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.activities"
                  ).toUpperCase()
                }}
              </b-th>
              <!-- Se tienen que crear por institución en los support-resource-type
              RECURSOS DE APRENDIZAJE y TECNOLOGÍA EDUCATIVA-->
              <b-th class="second-header">
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.learningResources"
                  ).toUpperCase()
                }}
              </b-th>
              <b-th class="second-header">
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.educationalTechnology"
                  ).toUpperCase()
                }}
              </b-th>
              <b-th class="second-header">
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.learningEnvironment"
                  ).toUpperCase()
                }}</b-th
              >
              <b-th class="second-header">
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.hoursCount"
                  ).toUpperCase()
                }}</b-th
              >
            </b-tr></b-thead
          >
          <b-tbody>
            <b-tr
              v-for="activity in learning_result.activities"
              :key="'activity_' + activity.id + learning_result.id"
            >
              <b-td class="text-left">{{ activity.name }}</b-td>
              <b-td>
                <template v-if="activity.learning_resources.length > 0">
                  <RenderVHtml
                    v-for="learning_resource in activity.learning_resources"
                    :key="'learning_resource_' + learning_resource.id"
                    class="mr-1"
                    :content="learning_resource.description"
                  ></RenderVHtml>
                </template>
                <template v-else>{{
                  $t("reusable.common.notApplicable")
                }}</template>
              </b-td>
              <b-td>
                <template v-if="activity.educational_technology.length > 0">
                  <RenderVHtml
                    v-for="educational in activity.educational_technology"
                    :key="'educational_' + educational.id"
                    class="mr-1"
                    :content="educational.description"
                  ></RenderVHtml>
                </template>
                <template v-else>{{
                  $t("reusable.common.notApplicable")
                }}</template>
              </b-td>
              <b-td>
                <template v-if="activity.study_environments.length > 0">
                  <!-- <b-badge
                    v-for="environment in activity.study_environments"
                    :key="'environment_' + environment.id"
                    variant="info"
                    class="mr-1"
                  >
                    {{ environment.name }}
                  </b-badge> -->
                  <div
                    v-for="environment in activity.study_environments"
                    :key="'environment_' + environment.id"
                    variant="info"
                    class="mr-1 text-left"
                  >
                    {{ environment.name }}
                  </div>
                </template>
                <template v-else>{{
                  $t("reusable.common.notApplicable")
                }}</template>
              </b-td>
              <b-td>
                {{ activity.suggested_hours }}
              </b-td>
            </b-tr>
            <b-tr v-if="learning_result.activities.length == 0">
              <b-td colspan="5">
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.noActivitiesInEntity",
                    {
                      entity: $t(
                        "matterProgram.learningSuitcaseTeacherView.learningExperience"
                      ),
                    }
                  )
                }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-table-simple
          class="page-break"
          bordered
          responsive
          :key="'evaluation_' + learning_result.id"
        >
          <b-thead>
            <b-tr>
              <b-th colspan="3" class="first-header"
                ><span class="general-background-icon mr-2">
                  <b-icon icon="star"></b-icon>
                </span>
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.evaluations"
                  ).toUpperCase()
                }}
              </b-th>
            </b-tr>
            <b-tr>
              <b-th class="second-header">
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.evaluationType"
                  ).toUpperCase()
                }}
              </b-th>
              <b-th class="second-header">
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.evaluativeSituation"
                  ).toUpperCase()
                }}
              </b-th>
              <b-th class="second-header">
                {{ $t("reusable.common.description").toUpperCase() }}
              </b-th>
            </b-tr></b-thead
          >
          <b-tbody>
            <b-tr
              v-for="evaluation in learning_result.evaluations"
              :key="evaluation.id + learning_result.id"
            >
              <td class="text-left">{{ evaluation.name }}</td>
              <td>
                {{
                  evaluation.evaluation_situations.length == 0
                    ? $t("reusable.common.notApplicable")
                    : evaluation.evaluation_situations.join(", ")
                }}
              </td>
              <td>
                <RenderVHtml
                  v-if="evaluation.description"
                  :content="evaluation.description"
                ></RenderVHtml>
                <div v-else>
                  {{
                    $t(
                      "matterProgram.learningSuitcaseTeacherView.withoutDescription"
                    )
                  }}
                </div>
              </td>
            </b-tr>
            <b-tr v-if="learning_result.evaluations.length == 0">
              <b-td colspan="3">
                {{
                  $t(
                    "matterProgram.learningSuitcaseTeacherView.noEvaluationsInEntity",
                    {
                      entity: $t(
                        "matterProgram.learningSuitcaseTeacherView.learningExperience"
                      ),
                    }
                  )
                }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </template>
    </template>
  </div>
</template>
<script>
import * as names from "@/store/names";
import matterLanguageMixin from "@/mixins/matterLanguageMixin";
import { mapGetters } from "vuex";
export default {
  name: "LearningSuitcaseTeacherView",
  mixins: [matterLanguageMixin],
  components: {
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  data() {
    return {
      egress_profile_matter_id: Number(
        this.$route.params.egress_profile_matter_id
      ),
      // egress_profile_linkage: null,
      suitcase_report: null,
      default_color: "var(--primary-font-color)",
      default_bg_color: "#f8f9fa",
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      institution_logo: "getInstitutionLogo",
      images: names.IMAGES,
      egressProfileMatters: names.EGRESS_PROFILES_MATTERS,
      egressProfiles: names.EGRESS_PROFILES,
    }),
    isProfessor() {
      return this.user && this.user.group_names.includes("PROFESORES");
    },
    isStudent() {
      return this.user && this.user.group_names.includes("ESTUDIANTES");
    },
    egressProfileMatter() {
      if (!this.egress_profile_matter_id) return null;
      return this.egressProfileMatters.find(
        (x) => x.id == this.egress_profile_matter_id
      );
    },
    egressProfile() {
      if (!this.egressProfileMatter) return null;
      return this.egressProfiles.find(
        (x) => x.id == this.egressProfileMatter.egress_profile
      );
    },
    facultyColor() {
      if (this.suitcase_report) {
        if (this.suitcase_report.matter_is_transversal) return "black";
        else return this.suitcase_report.faculty_color;
      }
      return "black";
    },
    // egressProfileLinked() {
    //   if (!this.egress_profile_linkage) return null;
    //   return this.egressProfiles.find(
    //     (x) => x.id == this.egress_profile_linkage.linked_egress_profile
    //   );
    // },
    suitcaseLearningResults() {
      // if (!this.suitcase_report.learning_results) return;
      let list = this.suitcase_report.learning_results;
      return list.sort((a, b) => a.order - b.order);
    },
    getTotalWeighing() {
      let total_weighing = 0;
      let total_weighing_sixty = 0;
      if (this.suitcase_report) {
        this.suitcase_report.partial_evaluations.forEach((x) => {
          total_weighing = total_weighing + x.weighing;
        });
        if (this.suitcase_report.transversal_exams.length > 0)
          total_weighing_sixty = total_weighing * 0.6;
        else total_weighing_sixty = total_weighing;
      }
      return total_weighing_sixty;
    },
    getAllTotalWeighing() {
      let total_partial = this.getTotalWeighing;
      let total_transversal = 0;
      let total_evaluations = 0;

      if (this.suitcase_report) {
        this.suitcase_report.transversal_exams.forEach((x) => {
          total_transversal = total_transversal + x.weighing;
        });
        total_evaluations = total_partial + total_transversal;
      }
      return total_evaluations;
    },
    breadcrumb() {
      // Recuperar contexto del breadcrumb desde localStorage
      const context = localStorage.getItem("breadcrumb");
      return context ? JSON.parse(context) : {};
    },
    breadcrumbEgressProfileId() {
      return this.breadcrumb.egress_profile_id || null;
    },
    breadcrumbEgressProfileMatterId() {
      return this.breadcrumb.egress_profile_matter_id || null;
    },
    breadcrumb_items() {
      let breadcrumb = [];
      let egressProfileId =
        this.breadcrumbEgressProfileId || this.egressProfile?.id;
      let egressProfileMatterId =
        this.breadcrumbEgressProfileMatterId || this.egress_profile_matter_id;

      if (egressProfileId && egressProfileMatterId) {
        breadcrumb = [
          {
            text: this.$t("reusable.breadcrumb.home"),
            to: "/home",
          },
          {
            text: this.$getVisibleNames("mesh.career", true, "Programas"),
            to: "/careers",
          },
          {
            text: this.$getVisibleNames("manual.matriz_2", false, "Matriz 2"),
            to: `/matrix2/form/${egressProfileId}`,
            dropdownOptions: [
              "showEgressProfile",
              "showMatrix1",
              "showMatrix2",
              "showMatrix3",
              "showMatrix4",
              "showStudyPlan",
              "showCurricularMesh",
            ],
          },
          {
            text: this.$getVisibleNames(
              "manual.matter_program",
              false,
              "Programa de la Asignatura"
            ),
            to: `/matter/form/${egressProfileMatterId}`,
          },
          {
            text: "PDA",
            ...(!this.isStudent &&
              !this.isProfessor && {
                dropdownOptions: [
                  "showMatterDescriptionView",
                  "showLearningEvaluationView",
                  "showLearningExperiencesView",
                  "showPiaView",
                  "showPaView",
                ],
              }),
          },
        ];
      }
      return breadcrumb;
    },
  },
  methods: {
    activityAndEvaluation(learning_result) {
      let list = learning_result.activities;
      list = list.concat(learning_result.evaluations);
      return list.sort((a, b) => a.order - b.order);
    },
    fetchSuitcaseReport() {
      if (this.egress_profile_matter_id) {
        this.$restful
          .Get(
            `/teaching/learning_suitcase/?egress_profile_matter=${this.egress_profile_matter_id}&learning_suitcase_option=6`
          )
          .then((response) => {
            this.suitcase_report = response;
          });
      }
    },
  },
  beforeDestroy() {
    this.$store.commit(names.RESET_TITLE_OF_THE_PRINT);
  },
  watch: {
    egressProfile: {
      immediate: true,
      handler(val) {
        if (!val) return;
        if (
          this.user &&
          this.user.student_card &&
          this.user.group_names.includes("ESTUDIANTES") &&
          this.user.student_card.egress_profile != val.id
        ) {
          this.$router.push({ name: "Page403" });
        }
        if (this.user && this.user.group_names.includes("PROFESORES")) {
          this.$restful
            .Get(`/mesh/fully_visible_professor_egress_profiles/`)
            .then((response) => {
              if (!response.includes(val.id)) {
                this.$router.push({ name: "Page403" });
              }
            });
        }
      },
    },
  },
  mounted() {
    this.fetchSuitcaseReport();
    if (this.egress_profile_matter_id)
      this.$store
        .dispatch(
          names.FETCH_EGRESS_PROFILE_MATTER,
          this.egress_profile_matter_id
        )
        .then((egress_profile_matter) => {
          this.$store
            .dispatch(names.FETCH_MATTER, egress_profile_matter.matter)
            .then((matter) => {
              this.$store.commit(
                names.MUTATE_TITLE_OF_THE_PRINT,
                `PDA - ${egress_profile_matter.effective_code} ${matter.name}`
              );
              this.applyMatterLanguageById(matter.default_language);
            });
          // this.$restful
          //   .Get(
          //     `/mesh/egress-profile-linkage/?linker_egress_profile=${egress_profile_matter.egress_profile}`
          //   )
          //   .then((response) => {
          //     if (response[0]) {
          //       this.egress_profile_linkage = response[0];
          //       this.$store.dispatch(
          //         names.FETCH_EGRESS_PROFILE,
          //         response[0].linked_egress_profile
          //       );
          //     }
          //   });
          this.$store.dispatch(
            names.FETCH_EGRESS_PROFILE,
            egress_profile_matter.egress_profile
          );
        });
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.descriptor-body {
  display: block;
  text-align: justify;
  padding: 0.4em;
  padding-inline: 1em;
}
.descriptor-body >>> p {
  margin-bottom: 0 !important;
}
.ra-badge,
.il-badge {
  border: 1px solid black !important;
  font-size: 9pt;
  letter-spacing: 0.3px;
}
.learning-result-badge1,
.learning-result-badge2,
.learning-result-badge3,
.evaluation-criteria-badge-activity,
.evaluation-criteria-badge-activity2,
.evaluation-criteria-badge-evaluation,
.evaluation-criteria-badge-evaluation2 {
  display: none;
}
.suitcase-header {
  display: flex;
  position: relative;
  height: 56px;
  align-items: center;
}
.suitcase-faculty {
  width: 100%;
  margin-left: 1%;
  margin-right: 1em;
}
.suitcase-title {
  vertical-align: top;
  font-weight: bold;
  letter-spacing: 2.5px !important;
  line-height: 0.9;
  white-space: nowrap;
}
.suitcase-title--en {
  letter-spacing: 1px !important;
}
.suitcase-title > .suitcase-title-2 {
  display: block;
  letter-spacing: -2px !important;
  font-weight: 100 !important;
}
.logo-container {
  display: flex;
  margin-left: auto;
  margin-right: 5em;
}
.logo-section {
  border-left: 1px solid;
  padding-left: 1em;
}
.logo-section > .institution-logo {
  max-height: 50px;
  transform: translateY(-25%);
  z-index: 1;
}
.left-header-text {
  width: 20%;
  margin-left: 1px;
}
.synthesis-header-container {
  display: flex;
  margin-left: 1px;
}
.empty-block {
  width: 5%;
}
.synthesis-header {
  background-color: black !important;
  width: 95%;
  margin-right: 1px;
  z-index: 10;
}
.first-header {
  background-color: #808080 !important;
  color: white;
}
.second-header {
  vertical-align: middle;
  background-color: #d9d9d9 !important;
}
.third-header {
  background-color: #bfbfbf !important;
}
.general-background-icon {
  padding: 0.3em;
  border-radius: 30px;
  border: 1px dotted;
}
.pre-requisites-tag {
  font-size: var(--secondary-font-size);
}
.suitcase-program-indications {
  border: 1px solid #dee2e6;
}
.program-indications-header {
  background: #808080 !important;
  color: white;
  border-bottom: 1px solid #dee2e6;
  font-weight: bold;
  padding: 0.7em;
}
.program-indications-body {
  padding: 1em;
}
.suitcase-matter-description {
  border: 1px solid #dee2e6;
}
.matter-description-header {
  padding: 0.7em;
  background-color: #808080 !important;
  color: white;
  font-weight: bold;
}
.matter-description-body {
  padding: 1em;
}
.suitcase-competences-th {
  vertical-align: middle;
  background-color: #808080 !important;
  color: white;
  min-width: 15em;
}
.suitcase-competences-td {
  text-align: left;
}
.suitcase-learning-results-th {
  vertical-align: middle;
  background-color: #808080 !important;
  color: white;
  min-width: 15em;
}
.suitcase-learning-results-td,
.suitcase-ec-micro-td {
  text-align: left;
}
.suitcase-learning-results-td {
  vertical-align: middle;
}
.learning-results-synthesis-th {
  background-color: #808080 !important;
  color: white;
}
.teaching-profile-header {
  vertical-align: middle;
  background-color: #d9d9d9 !important;
}
.assistant-header {
  padding: 0.7em;
  background-color: #808080 !important;
  color: white;
  font-weight: bold;
}
.assistant-container {
  display: flex;
  border: 1px solid #dee2e6;
}
.assistant-drop-header {
  background-color: #d9d9d9 !important;
  font-weight: bold;
}
.assistant-content {
  padding: 1em;
}
.biblio-header {
  vertical-align: middle;
  background-color: #d9d9d9 !important;
}
.learning-result-order {
  width: 10%;
}
.learning-experiences-header-drop {
  margin-left: -10%;
}
@media print {
  .badge {
    border: none;
  }
  .learning-result-badge1,
  .learning-result-badge2,
  .learning-result-badge3,
  .evaluation-criteria-badge-activity,
  .evaluation-criteria-badge-activity2,
  .evaluation-criteria-badge-evaluation,
  .evaluation-criteria-badge-evaluation2 {
    display: flex;
    text-align: justify;
  }
}
.page-break {
  page-break-before: auto;
  page-break-after: auto;
  page-break-inside: avoid;
}
</style>